import isBase64Image from "./isBase64Image";
export default (url, callback) => {
    if (isBase64Image(url)) {
        callback(url);
        return;
    }
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        };
        reader.onerror = function () {
            callback(null);
        };
        reader.onabort = function () {
            callback(null);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.onerror = function () {
        callback(null);
    };
    xhr.onabort = function () {
        callback(null);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
};
